// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__4Ah3v","modalFooterButton":"ModalNotes_modalFooterButton__1C9Th"};